import { Card, CardContent, Box } from "@mui/material";

import React, { useEffect, useState } from "react";
import { TextInput, TextArea } from "cprime-foundational-components";
import * as style from "./ValueStreams.module.scss";

import Button from "../../Components/Common/CprimeButton";
import Typography from "../../Components/Common/CprimeText";
interface ValueStream {
  id: number;
  featureName: string;
  featureDescription: string | null;
  disabled?: boolean;
  isChecked?: boolean;
}

const ValueStreamsCard: React.FC<{
  group: any;
  name: any;
  description: any;
  id: any;
  expandedCards: any;
  toggleAllFeatures: any;
  toggleFeature: any;
  handleDelete: any;
  updateValueStream: Function;
  setName: Function;
  setDescription: Function;
}> = ({ name, description, updateValueStream, setName, setDescription }) => {
  const scssClass = style as any;
  const [nameValueStream, setNameValueStream] = useState(name);
  const [desValueStream, setDesValueStream] = useState(description);
  const [enabledSaveButton, setEnabledSaveButton] = useState(true);

  useEffect(() => {
    setNameValueStream(name);
    setDesValueStream(description);
    setEnabledSaveButton(true); // Reset save button when prop changes
  }, [name, description]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e?.target?.value;
    setNameValueStream(newValue);
    setEnabledSaveButton(newValue === name); // Enable button only if value hasn't changed
  };

  const handleChangeDes = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e?.target?.value;
    setDesValueStream(newValue);
    setEnabledSaveButton(newValue === description); // Enable button only if value hasn't changed
  };

  return (
    <>
      <Box sx={{ maxWidth: "120%", margin: "auto", mt: 2 }}>
        <Card elevation={0}>
          <CardContent>
            <Typography variant="body1" gutterBottom>
              <TextInput
                value={nameValueStream}
                className={scssClass.textField}
                style={{ width: "469.33px" }}
                onChange={handleChange}
                placeholder="Enter Name"
                label="Value Stream Name"
              />
            </Typography>
            <Typography
              variant="body1"
              gutterBottom
              style={{ marginTop: "15px" }}
            >
              <TextArea
                fullWidth
                label={<>Description</>}
                aria-label="minimum height"
                minRows={3}
                placeholder="Enter Description"
                style={{ width: "100%" }}
                value={desValueStream}
                onChange={handleChangeDes}
                maxLength={500}
              />
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Card elevation={0} sx={{ width: "100%", mt: 2 }}>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="primary"
              disabled={enabledSaveButton}
              onClick={() => {
                updateValueStream(nameValueStream, desValueStream);
              }}
              style={{ marginRight: "12px", marginTop: "5px" }}
            >
              Save
            </Button>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default ValueStreamsCard;
